export default "__VITE_ASSET__DeY6GJu7__"